/**
 * Algoritmo que calcula los pesos de los dígitos de un rif. Este algoritmo es válido solo para un rif que comience con la letra 'J'
 * @param rif: Campo numérico de 9 dígitos
 * @return boolean que indica si los dígitos del rif son correctos o no
 * **/
export const verificarRif = (rif,letraInicial, nat) => {
	var pesos = new Array(4, 3, 2, 7, 6, 5, 4, 3, 2);
	var acum = 0;
	var acumR = 0;
	var nacionalidad = nat ? Number(nat) : 0;
	
/* if (document.getElementById('nacionalidad')!=null)
    nacionalidad=document.getElementById('nacionalidad').value;  */

	//Se asignan los pesos para cada uno de los dígitos
	for(var ind=1; ind<=8; ind++) {
		acum += (parseInt(rif?.charAt(ind-1)) * pesos[ind]);
	}
	
	if (acum == 0)
		return false;

	acumR = acum;
	
	switch(letraInicial)
	{
	 	case 'v':
			acum += parseInt(pesos[0]);
		break;
	    case 'e':
			acum += parseInt(pesos[0]) * 2;
	    break;
		case 'g':
			acum += parseInt(pesos[0]) * 5;
		break;
		case 'c':case 'j':
	        acum += parseInt(pesos[0]) * 3;
		break;
		case 'r':
			if (nacionalidad>0)
				acum += parseInt(pesos[0]) * 2;
			else
				acum += parseInt(pesos[0]);
	    break;
	}
	
	acum = acum % 11;
	
	if (acum > 1)
		acum = 11 - acum;	
	else
		acum = 0;	
	
    //Se compara el cálculo con el último dígito verificador
	if (parseInt(rif?.charAt(rif.length-1)) == acum)
	{
		return true;
	} 
	else
	{
		//en caso de r existe una validacion con pasaporte, pero este campo no esta en el formulario
		//por lo que se calcula a parte con un peso de 4
		if (letraInicial == 'r') {
			acumR += parseInt(pesos[0]) * 4;
			acumR = acumR % 11;
			if (acumR > 1)
				acumR = 11 - acumR;	
			else
				acumR = 0;
			if (parseInt(rif?.charAt(rif.length-1)) == acumR)
				return true;
		}
		
		return false;
	}
}


/**
 * Algoritmo que verifica si un rif es correcto
 * @param rif: un campo rif debe ser de 10 caracteres compuesto por una letra inicial('J','G','R') y por 9 caracteres numéricos
 * @return boolean que indica si un rif es válido o no
 * **/
export const isRif = (rif, nat) => {
	var rifNumber = '';
	
	//Se verifica si el rif comienza con alguna de las letras(J,G,R,C)
	if ((rif?.charAt(0)?.toLowerCase()!='j')&&(rif?.charAt(0)?.toLowerCase()!='g')&&(rif?.charAt(0)?.toLowerCase()!='r')&&(rif?.charAt(0)?.toLowerCase()!='v')&&(rif?.charAt(0)?.toLowerCase()!='e')&&(rif?.charAt(0)?.toLowerCase()!='c'))
	{
		return false;
	}
	else
	{
		rifNumber = rif.substring(1);		
	}
	
	//Se verifica si el resto de los caracteres del rif son numéricos
	if (!isNaN(rifNumber))
	{	
		//Se verifica si la longitud de los dígitos es la correcta
		if (rifNumber.length==9)
		{
			return verificarRif(rifNumber,rif?.charAt(0)?.toLowerCase(), nat);
		}
		else
		{
			return false;
		}
	}
	else
	{
		return false;	
	}
}